import { forwardRef, useRef } from 'react'

import { SnackbarContent, SnackbarKey, SnackbarMessage } from 'notistack'

import useTrackEvents from '~/events/trackers/useTrackEvents'
import CloseX from '~/images/icons/SystemOutlined/Close.svg'
import { useSnackbar } from '~/libs/notistack'

interface ErrorSnackbarProps {
  id: SnackbarKey
  message: SnackbarMessage
}

const ErrorSnackbar = forwardRef<HTMLDivElement, ErrorSnackbarProps>(({ message, id }, ref) => {
  const didSendEvent = useRef<boolean>(false)
  const { closeSnackbar } = useSnackbar()
  const { trackErrorDisplay } = useTrackEvents()

  const onChangeTitleRef = (contentRef: HTMLSpanElement | null) => {
    if (contentRef && !didSendEvent.current) {
      didSendEvent.current = true
      trackErrorDisplay({ error_message: contentRef.innerText ?? '' })
    }
  }

  return (
    <SnackbarContent ref={ref} id={id as string} style={{ display: 'grid' }}>
      <div className='flex flex-row rounded-lg bg-surface-alert border border-border-alert p-6 gap-4 max-w-[360px]'>
        <div className='text-body-text-2 flex-1 break-words' ref={(contentRef) => onChangeTitleRef(contentRef)}>
          {message}
        </div>
        <CloseX
          title='close-message'
          onClick={() => closeSnackbar()}
          className='text-icon-subdued cursor-pointer w-[24px] h-[24px] min-w-[24px]'
        />
      </div>
    </SnackbarContent>
  )
})

export default ErrorSnackbar
